module.exports = __webpack_public_path__ + "static/media/bowen-23.40dd8b1e.jpg";